import { render, staticRenderFns } from "./ANxMExMedicationsPage.vue?vue&type=template&id=51fed16a"
import script from "./ANxMExMedicationsPage.vue?vue&type=script&lang=js"
export * from "./ANxMExMedicationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports